<template>
  <ul class="card-meta-list">
    <slot />
  </ul>
</template>

<style lang="scss">
.card-meta-list {
  list-style-type: none;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 24px;
  margin: 0;
  padding: 0;
}
</style>
